<script setup lang="ts">
  withDefaults(
    defineProps<{
      /** Displayed value, e.g. "1 000" (use NBSP thousands separator). */
      value?: string
      unit?: string
      /** Fill percentage 0–100. */
      percent?: number
      meta?: string
      max?: string
    }>(),
    {
      value: '1 000',
      unit: 'MBIT/S DOWN',
      percent: 88,
      meta: 'Live',
      max: '1 000',
    },
  )
</script>

<template>
  <div class="speed-meter">
    <div class="speed-meter__readout">
      <div class="speed-meter__value">
        <em>{{ value }}</em>
      </div>
      <div class="speed-meter__unit">{{ unit }}</div>
    </div>
    <div class="speed-meter__gauge">
      <div class="speed-meter__track">
        <div class="speed-meter__bar" :style="{ width: `${Math.min(100, Math.max(0, percent))}%` }"></div>
      </div>
      <div class="speed-meter__footnote">
        <span>0</span>
        <span>{{ meta }}</span>
        <span>{{ max }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .speed-meter {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 24px;
    background: var(--bf-deep-blue);
    color: var(--bf-white);
    border-radius: var(--bf-r-lg);

    &__value {
      font-family: var(--bf-font-display);
      font-weight: var(--bf-fw-black);
      font-size: 80px;
      letter-spacing: -0.04em;
      line-height: 1;

      em {
        font-style: italic;
        color: var(--bf-orange-light);
      }
    }

    &__unit {
      font-family: var(--bf-font-mono);
      font-size: 13px;
      color: var(--bf-dusky-2);
      margin-top: 6px;
      letter-spacing: 0.08em;
    }

    &__gauge {
      flex: 1;
    }

    &__track {
      height: 10px;
      background: rgba(145, 155, 175, 0.18);
      border-radius: var(--bf-r-pill);
      overflow: hidden;
    }

    &__bar {
      height: 100%;
      background: linear-gradient(90deg, var(--bf-orange-dark), var(--bf-orange-light));
      border-radius: var(--bf-r-pill);
      box-shadow: 0 0 12px rgba(240, 141, 0, 0.55);
      transition: width var(--bf-dur-slow) var(--bf-ease);
    }

    &__footnote {
      display: flex;
      justify-content: space-between;
      margin-top: 8px;
      font-family: var(--bf-font-mono);
      font-size: 11px;
      color: var(--bf-dusky-2);
    }
  }
</style>
